import React from 'react'
import { Link } from 'react-router-dom';
import Contact_1 from '../../../assets/images/svg/footer-two/footer-two-mail.svg';
import Contact_2 from '../../../assets/images/svg/footer-two/footer-two-address.svg';


const Contact = () => {
    return (
        <>
            <div className="contact-section-four">
                <div className="container">
                    <div className="row justify-content-end">
                        <div className="col-xl-8">
                            <div
                                className="contact-form-four animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="heading-box">
                                    <span
                                        className="sub-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                    >
                                        Contact Us
                                    </span>
                                    <h2
                                        className="heading-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                        data-wow-delay="200ms"
                                    >
                                        Get In Touch Here!
                                    </h2>
                                </div>
                                <ul className="contact-location-four">
                                    <li>
                                        <span>
                                            <img
                                                src={Contact_1}
                                                alt="icon"
                                            />
                                        </span>
                                        <Link to="mailto:needhelp@company.com">needhelp@company.com</Link>
                                    </li>
                                    <li>
                                        <span>
                                            <img
                                                src={Contact_2}
                                                alt="icon"
                                            />
                                        </span>
                                        <p>135 klf, Hotland, USA</p>
                                    </li>
                                </ul>
                                <form action="#">
                                    <div className="form-group-four">
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            placeholder="Name"
                                            required=""
                                        />
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-control"
                                            placeholder="Email"
                                            required=""
                                        />
                                    </div>
                                    <div className="form-group-four">
                                        <input
                                            type="text"
                                            name="subject"
                                            className="form-control"
                                            placeholder="Subject"
                                            required=""
                                        />
                                        <input
                                            type="text"
                                            name="services"
                                            className="form-control"
                                            placeholder="Services"
                                            required=""
                                        />
                                    </div>
                                    <div className="form-group-four">
                                        <textarea
                                            name="message"
                                            className="form-control"
                                            rows={4}
                                            placeholder="Message"
                                            required=""
                                            defaultValue={""}
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-secondary btn-theme">
                                        Send <span>+</span>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        </>
    )
}

export default Contact
